import RiskScore from './RiskScore/View'

const abundanceEngineExports = {
  OrionRiskScore: RiskScore
}

export default abundanceEngineExports
